import { sessionAccess } from './session-access';
import api from './api';

export const WEB_APP_NAME = 'ERP' as const;

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginPayload extends LoginCredentials {
  web_app_name: typeof WEB_APP_NAME;
}

export interface LoginResponse {
  token: string;
}

export async function login(credentials: LoginCredentials): Promise<void> {
  try {
    const payload: LoginPayload = {
      ...credentials,
      web_app_name: WEB_APP_NAME
    };
    const response = await api.post<LoginResponse>('/auth/token/', payload);
    const { token } = response.data;
    await sessionAccess.verify(true, token);
    localStorage.setItem('auth_token', token);
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
}

export function logout(): void {
  localStorage.removeItem('auth_token');
  window.location.href = '/xac-thuc';
}

export function getToken(): string | null {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return localStorage.getItem('auth_token');
}

export function isAuthenticated(): boolean {
  return !!getToken();
}
